<template>
  <div class="ads-bank-transfer">
    <p class="txt-title">{{ $t('ads_bank_transfer_title') }}</p>
    <p class="txt-title my-4">{{ $t('ads_bank_transfer_info') }}</p>
    <div class="flex flex-col gap-2">
      <div class="flex justify-between gap-2">
        <p class="txt-bank-title">{{ $t('ads_bank_account_name') }}</p>
        <p class="txt-bank-value">
          {{ bankTransferInfo.bankAccountName || '' }}
        </p>
      </div>
      <div class="flex justify-between gap-2">
        <p class="txt-bank-title">{{ $t('ads_iban') }}</p>
        <p class="txt-bank-value">{{ bankTransferInfo.iBan || '' }}</p>
      </div>
      <div class="flex justify-between gap-2">
        <p class="txt-bank-title">{{ $t('ads_bank') }}</p>
        <p class="txt-bank-value">{{ bankTransferInfo.bank || '' }}</p>
      </div>
      <div class="flex justify-between gap-2">
        <p class="txt-bank-title">{{ $t('ads_swift_code') }}</p>
        <p class="txt-bank-value">{{ bankTransferInfo.swiftCode || '' }}</p>
      </div>
    </div>
    <div class="flex mt-4 gap-4">
      <BaseButton
        type="tertiary"
        class="flex-1"
        track-id="ads_postpaid_bank_transfer_cancel"
        @click="$router.go('-1')"
      >
        {{ $t('ads_top_up_cancel') }}
      </BaseButton>
      <BaseButton
        type="primary"
        class="flex-1 whitespace-no-wrap"
        track-id="ads_postpaid_bank_transfer_confirm_paid"
        @click="onCheck"
      >
        {{ $t('ads_have_paid') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/lavender/v2/BaseButton.vue'
import { BANK_TRANSFER_INFO_BY_CURRENCY } from '@/views/farah/constants/bank-transfer-info'

export default {
  name: 'AdsPostpaidBankTransfer',
  components: {
    BaseButton,
  },
  props: {
    isPending: {
      type: Boolean,
      default: false,
    },
    paymentData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    bankTransferInfo() {
      const currency = this.paymentData?.billingAddress?.currency || ''

      return BANK_TRANSFER_INFO_BY_CURRENCY[currency] || {}
    },
  },
  methods: {
    onCheck() {
      this.$emit('update:isPending', true)
    },
  },
}
</script>

<style lang="scss" scoped>
.txt-title {
  font-size: 14px;
  font-weight: 400;
}

.txt-bank-title {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--content-mid);
}

.txt-bank-value {
  font-size: 14px;
  font-weight: 400;
  text-align: end;
}
</style>
